import { ButtonHeading, CustomPagination, SelectListButton, SelectListModal, UpdateModal } from 'components';
import React, { useEffect, useRef, useState } from 'react'
import { AiOutlineTool } from 'react-icons/ai';
import { FaArrowTrendUp, FaRegCircleCheck } from 'react-icons/fa6';
import './vehiclePlanning.css';
import { getPlaningCounts, getVehiclePlaningList } from '_services/accountsServices/vehicleServices';
import StorageService from 'utils/StorageServices';
import LoadingBar from 'react-top-loading-bar';
import { utils } from 'helper';
import Loading from 'pages/Loading';
import { API, AppConfig } from 'lib';
import toast from 'react-hot-toast';

import { GOOGLE_MAP_API_KEY } from 'lib/app-config';
import CustomTooltip from "components/CustomTooltip/CustomTooltip";

const GEO_CACHE_KEY = 'geoCache_v1';

let memoryCache = {};

const getCache = () => {
    if (Object.keys(memoryCache).length) return memoryCache;
    const local = localStorage.getItem(GEO_CACHE_KEY);
    memoryCache = local ? JSON.parse(local) : {};
    return memoryCache;
};

const setCache = (cache) => {
    memoryCache = cache;
    localStorage.setItem(GEO_CACHE_KEY, JSON.stringify(cache));
};

const getBestAddress = (results = []) => {
    if (!results.length) return "N/A";

    const priorityTypes = [
        "street_address",
        "route",
        "locality",
        "sublocality",
        "administrative_area_level_3",
    ];

    for (let type of priorityTypes) {
        const found = results.find(r => r.types.includes(type));
        if (found) return found.formatted_address;
    }

    return results[0]?.formatted_address || "N/A";
};

// const fetchAddress = async (lat, lng) => {
//     const cache = getCache();
//     const key = `${lat}-${lng}`;

//     if (cache[key]) return cache[key];

//     try {
//         const res = await fetch(
//             `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAP_API_KEY}`
//         );
//         const data = await res.json();
//         const address = getBestAddress(data?.results);

//         cache[key] = address;
//         setCache(cache);

//         return address;
//     } catch (err) {
//         return "N/A";
//     }
// };

const fetchAddress = async (lat, lng) => {
    const cache = getCache();
    const key = `${lat}-${lng}`;

    if (cache[key]) return cache[key];

    try {
        const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
            {
                headers: {
                    "User-Agent": "transport360" // important
                }
            }
        );

        const data = await res.json();

        const address = ((data?.address?.city_district && data?.address?.state) ? `${data?.address?.city_district}, ${data?.address?.state}` : ((data?.address?.state_district != undefined && data?.address?.state_district != '') ? data?.address?.state_district : data?.display_name)) || "N/A";

        cache[key] = address;
        setCache(cache);

        return address;
    } catch (err) {
        return "N/A";
    }
};

const VehiclePlanning = () => {

    let isToken = localStorage.getItem("token");
    const loadingBarRef = useRef(null);
    const [vehiclePlaningList, setVehiclePlaningList] = useState([]);
    const [planingCounts, setPlaningCounts] = useState({})
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        company_id: StorageService.getCompanyId(),
        limit: 25,
        offset: 1,
        search: "",
        status: 0, // 1
        gps_status: 0,
        last_updated: 0,
        running_status: 0, // 1
        upcoming_plan: 0, // 1
        vehicle_status: 0,
        updated_user_id: {},
        vehicle_group_id: {},
    });

    const [showSelectListModal, setShowSelectListModal] = useState({ type: '', action: false, name: '' });
    const [updateModal, setUpdateModal] = useState({});

    console.log('updateModal', updateModal)

    const handleCallBack = (data) => {
        setFilter((s) => ({
            ...s,
            ...data
        }))
        setShowSelectListModal({ type: '', action: false, name: '' })
    }

    let updateListProps = {
        isOpen: showSelectListModal,
        closeModal: (e) => setShowSelectListModal(false),
        onSubmit: (data) => handleCallBack(data),
        modalMainClass: " _dashCommon_Modal  _mdModal  __updateListModal",
        headerPart: true,
        floatCrossBtn: true,
        modalTitle: showSelectListModal?.name,
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
    };

    let updateDataModal = {
        isOpen: updateModal,
        closeModal: (e) => setUpdateModal({}),
        // onSubmit: (e) => setUpdateModal({}),
        modalMainClass: " _dashCommon_Modal  _mdModal __updateListModal",
        headerPart: true,
        floatCrossBtn: true,
        modalTitle: "Update Status",
        submitTitle: "Update Status",
        callListApi: (e) => fetchVehiclePlaningListData(e),
    };

    const getAddressesBatch = async (list, batchSize = 10) => {
        const uniqueCoords = [
            ...new Set(
                list
                    ?.filter(i => i?.gps_info?.latitude && i?.gps_info?.longitude)
                    .map(i => `${i.gps_info.latitude}-${i.gps_info.longitude}`)
            )
        ];
        const result = {};
        const cache = getCache();
        for (let i = 0; i < uniqueCoords.length; i += batchSize) {
            const batch = uniqueCoords.slice(i, i + batchSize);
            const promises = batch.map(async (coord) => {
                if (cache[coord]) {
                    result[coord] = cache[coord];
                    return;
                }
                const [lat, lng] = coord.split("-");
                const address = await fetchAddress(lat, lng);
                result[coord] = address;
            });
            await Promise.all(promises);
        }
        return result;
    };

    const fetchVehiclePlaningListData = async () => {
        setLoading(true);
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let obj = {
                company_id: StorageService.getCompanyId(),
                limit: filter?.limit,
                offset: filter?.offset,
                vehicle_status: filter?.vehicle_status,
                search: filter?.search,
                status: filter?.status || 0,
                gps_status: filter?.gps_status || 0,
                last_updated: filter?.last_updated || 0,
                running_status: filter?.running_status || 0,
                upcoming_plan: filter?.upcoming_plan || 0,
                updated_user_id: filter?.updated_user_id?.value || "",
                vehicle_group_id: filter?.vehicle_group_id?.value || "",
            }
            const res = await getVehiclePlaningList(obj);
            if (res?.responseCode === 200) {
                const rawList = res?.data?.plan_list || [];
                const addressMap = await getAddressesBatch(rawList);
                const enrichedList = rawList.map(item => {
                    const lat = item?.gps_info?.latitude;
                    const lng = item?.gps_info?.longitude;

                    if (!lat || !lng) {
                        return { ...item, address: "-" };
                    }

                    const key = `${lat}-${lng}`;

                    return {
                        ...item,
                        address: addressMap[key] || "Loading..."
                    };
                });

                setVehiclePlaningList(enrichedList);

                setTotalItems(res?.data?.total_record);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
            setLoading(false);
        }
    }

    const fetchPlaningCountsData = async () => {
        setLoading(true);
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let obj = {
                company_id: StorageService.getCompanyId(),
                limit: filter?.limit,
                offset: filter?.offset,
                vehicle_status: filter?.vehicle_status,
                search: filter?.search,
                status: filter?.status || 0,
                gps_status: filter?.gps_status || 0,
                last_updated: filter?.last_updated || 0,
                running_status: filter?.running_status || 0,
                upcoming_plan: filter?.upcoming_plan || 0,
                updated_user_id: filter?.updated_user_id?.value || "",
                vehicle_group_id: filter?.vehicle_group_id?.value || "",
            }
            const res = await getPlaningCounts(obj);
            if (res?.responseCode === 200) {
                setPlaningCounts(res?.data);
                // setTotalItems(res?.data?.total_record);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchVehiclePlaningListData();
        fetchPlaningCountsData();
    }, [filter])

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const handleOnChange = async (name, value) => {
        const stateObj = { ...filter, [name]: value };
        setFilter(stateObj);
    };

    const documentExportHandler = async () => {
        setDownloadLoading(true);
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                limit: filter?.limit,
                offset: filter?.offset,
                vehicle_status: filter?.vehicle_status,
                search: filter?.search,
                status: filter?.status || 0,
                gps_status: filter?.gps_status || 0,
                last_updated: filter?.last_updated || 0,
                running_status: filter?.running_status || 0,
                upcoming_plan: filter?.upcoming_plan || 0,
                updated_user_id: filter?.updated_user_id?.value || "",
                vehicle_group_id: filter?.vehicle_group_id?.value || "",
            }

            const baseUrl = `${AppConfig.api_baseurl}${API.VEHICLE_DOCUMENT_DOWNLOAD_EXCEL}`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `vehicle_planning.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setDownloadLoading(false);
        } catch (error) {
            setDownloadLoading(false);
        }
    }

    return (
        <>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <div className='__vhlPlanning_mainBx'>
                <ButtonHeading
                    title="Vehicle Planning"
                    showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
                    filter={filter}
                    setFilter={setFilter}
                    isDebouncedSearch={false}

                    singleDocumentExport={true}
                    singleDocumentExportName="Download Excel"
                    singleDocumentExportHandler={(e) => documentExportHandler(e)}
                    exportLoading={downloadLoading}
                />

                <div className="_indentView_flx">
                    <div className="indentSide_bx">
                        <div className="_indtsLs_flx">
                            <div className="_indtsList">
                                <h5>Vehicle Status</h5>
                                <div className="_bidsLs_flx">
                                    {planingCounts?.vehicle_status?.map((item, index) => {
                                        return (
                                            <div className="_bidsList" key={`${item.id}-${index}`}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={item.id + item.name + index}
                                                    type="radio"
                                                    name="vehicle_status"
                                                    checked={filter?.vehicle_status === item.id}
                                                    onChange={() => handleOnChange('vehicle_status', item?.id)}
                                                // disabled={filter?.vehicle_status != 1}
                                                />
                                                <label htmlFor={item.id + item.name + index}>
                                                    <span>{item.name}</span>
                                                    <span>{item.count}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Running Status</h5>
                                <div className="_bidsLs_flx">
                                    {planingCounts?.running_status?.map((item, index) => {
                                        return (
                                            <div className="_bidsList" key={`${item.id}-${index}`}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={item.id + item.name + index}
                                                    type="radio"
                                                    name="running_status"
                                                    checked={filter?.running_status === item.id}
                                                    onChange={() => handleOnChange('running_status', item?.id)}
                                                // disabled={planFilter?.plan_status != 1}
                                                />
                                                <label htmlFor={item.id + item.name + index}>
                                                    <span>{item.name}</span>
                                                    <span>{item.count}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Upcoming Plan</h5>
                                <div className="_bidsLs_flx">
                                    {planingCounts?.upcoming_plan?.map((item, index) => {
                                        return (
                                            <div className="_bidsList" key={`${item.id}-${index}`}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={item.id + item.name + index}
                                                    type="radio"
                                                    name="upcoming_plan"
                                                    checked={filter?.upcoming_plan === item.id}
                                                    onChange={() => handleOnChange('upcoming_plan', item?.id)}
                                                // disabled={planFilter?.plan_status != 1}
                                                />
                                                <label htmlFor={item.id + item.name + index}>
                                                    <span>{item.name}</span>
                                                    <span>{item.count}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Last updated</h5>
                                <div className="_bidsLs_flx">
                                    {planingCounts?.last_updated?.map((item, index) => {
                                        return (
                                            <div className="_bidsList" key={`${item.id}-${index}`}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={item.id + item.name + index}
                                                    type="radio"
                                                    name="last_updated"
                                                    checked={filter?.last_updated === item.id}
                                                    onChange={() => handleOnChange('last_updated', item?.id)}
                                                // disabled={planFilter?.last_updated != 1}
                                                />
                                                <label htmlFor={item.id + item.name + index}>
                                                    <span>{item.name}</span>
                                                    <span>{item.count}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5> GPS Status </h5>
                                <div className="_bidsLs_flx">
                                    {planingCounts?.gps_status?.map((item, index) => {
                                        return (
                                            <div className="_bidsList" key={`${item.id}-${index}`}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={item.id + item.name + index}
                                                    type="radio"
                                                    name="gps_status"
                                                    checked={filter?.gps_status === item.id}
                                                    onChange={() => handleOnChange('gps_status', item?.id)}
                                                // disabled={planFilter?.gps_status != 1}
                                                />
                                                <label htmlFor={item.id + item.name + index}>
                                                    <span>{item.name}</span>
                                                    <span>{item.count}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Updated By</h5>

                                <div className='_optFilts' style={{ marginTop: '8px', paddingLeft: '15px' }}>
                                    <SelectListButton
                                        onClick={() => setShowSelectListModal({ type: 'updated_user_id', action: true, name: 'Updated By', data: filter?.updated_user_id })}
                                        selectTxt={filter?.updated_user_id?.label ? filter?.updated_user_id?.label : 'All Users'}
                                        crossIcon={filter?.updated_user_id?.label ? true : false}
                                        crossIconOnlick={() => { setFilter((s) => ({ ...s, updated_user_id: {} })); setShowSelectListModal({ type: 'updated_user_id', action: false, name: 'Updated By', data: {} }) }}
                                    />
                                </div>
                            </div>
                            <div className="_indtsList">
                                <h5>Vehicle Group</h5>

                                <div className='_optFilts' style={{ marginTop: '8px', paddingLeft: '15px' }}>
                                    <SelectListButton
                                        onClick={() => setShowSelectListModal({ type: 'vehicle_group_id', action: true, name: 'Vehicle Group', data: filter?.vehicle_group_id })}
                                        selectTxt={filter?.vehicle_group_id?.label ? filter?.vehicle_group_id?.label : 'All Users'}
                                        crossIcon={filter?.vehicle_group_id?.label ? true : false}
                                        crossIconOnlick={() => { setFilter((s) => ({ ...s, vehicle_group_id: {} })); setShowSelectListModal({ type: 'vehicle_group_id', action: false, name: 'Vehicle Group', data: {} }) }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="_indTabl_right">
                        <div className="_indentTable _planLTable">
                            <div className="accordion" id="indentTableAccordian">
                                <table className="__tPlain_table">
                                    <thead>
                                        <tr>
                                            <th>Vehicle Number</th>
                                            <th>Route Details</th>
                                            <th>Start Date</th>
                                            <th>Due Date</th>
                                            <th>Available Date</th>
                                            <th>Manual Remarks</th>
                                            <th>Updated By</th>
                                            <th>Upcoming Plan</th>
                                            <th>GPS Location</th>
                                            <th>Driver Name</th>
                                            <th>Vehicle Group</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            vehiclePlaningList?.length > 0 ?
                                                vehiclePlaningList?.map((item, indx) => {
                                                    return (
                                                        <React.Fragment key={item?._id || indx}>
                                                            <tr>
                                                                <td>
                                                                    <div className='_vlPln_div'><p> {item?.vehicle_no ? item?.vehicle_no : '-'} </p></div>
                                                                </td>

                                                                <td>
                                                                    {(item?.route_details?.status_label || item?.route_details?.route || item?.route_details?.trip_no) ? <div className='_rdPlan_div'>
                                                                        <div className='__vpOnTrip_st'><FaArrowTrendUp /> {item?.route_details?.status_label ? item?.route_details?.status_label : '-'}</div>
                                                                        <p>{item?.route_details?.route ? item?.route_details?.route : '-'}</p>
                                                                        <span>{item?.route_details?.trip_no ? item?.route_details?.trip_no : '-'}</span>
                                                                    </div> :
                                                                        <p> - </p>
                                                                    }
                                                                </td>

                                                                <td>
                                                                    <p> {item?.start_date ? utils.customizeDate(item?.start_date, true) : '-'} </p>
                                                                    <div className='_stPlan_div'>
                                                                        <p>{item?.start_date ? utils.getTimeAgo(item?.start_date) : '-'}</p>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div className='_duPlan_div'>
                                                                        <p> {item?.due_date ? utils.customizeDate(item?.due_date, true) : '-'}</p>
                                                                        <p>{item?.due_date ? utils.convertToIST(item?.due_date) : '-'}</p>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div className={`_availPlan_div ${item?.route_details?.status_label === 'On Trip' ? `_onTimeAvail` : (item?.route_details?.status_label === 'Maintenance' ? `_onMaintenAvail` : `_lateAvail`)} `}>
                                                                        <p>{item?.availability?.date ? utils.customizeDate(item?.availability?.date, true) : '-'}</p>
                                                                        <p>{item?.availability?.date ? utils.convertToIST(item?.availability?.date) : '-'}</p>
                                                                        <span>{item?.availability?.remark ? item?.availability?.remark : '-'}</span>
                                                                        <span>{item?.availability?.time_diff ? item?.availability?.time_diff : '-'}</span>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    {
                                                                        item?.manual_remarks?.status_type ?
                                                                            <div className='_manPlan_div'>
                                                                                <p>{item?.manual_remarks?.status_type ? item?.manual_remarks?.status_type : ''}</p>
                                                                                <p>{item?.manual_remarks?.selection_type ? item?.manual_remarks?.selection_type : ''}</p>
                                                                                {(() => {
                                                                                    const value = String(item?.manual_remarks?.remarks);

                                                                                    return value.length > 20 ? (
                                                                                        <CustomTooltip
                                                                                            txtClass="__tooltipTxt_bx"
                                                                                            cstStyle={{ maxWidth: "138px" }}
                                                                                        >
                                                                                            <p style={{ marginBottom: 0 }}>{value}</p>
                                                                                        </CustomTooltip>
                                                                                    ) : (
                                                                                        <div className="__NottooltipTxt">
                                                                                            <p style={{ marginBottom: 0 }}>{value || ""}</p>
                                                                                        </div>
                                                                                    );
                                                                                })()}
                                                                                <button className='vhPlan_updateStatus' onClick={() => setUpdateModal({ ...item, edit: true })} style={{ marginTop: '4px' }}>Update Status</button>
                                                                            </div> :
                                                                            <button className='add_planVhl' onClick={() => setUpdateModal(item)}> + Update Status </button>
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {item?.updated_by?.name ? <div className='_updPlan_div'>
                                                                        <p>{item?.updated_by?.name ? item?.updated_by?.name : '-'}</p>
                                                                        <p>{item?.updated_by?.time ? utils.getTimeAgo(item?.updated_by?.time, true) : '-'}</p>
                                                                    </div> : '-'}
                                                                </td>

                                                                <td className='_upComPlan_div'>
                                                                    <button className='add_planVhl'>+ Add Plan</button>
                                                                </td>

                                                                <td>
                                                                    {/* {item?.gps_info?.status ? <div className='_gpsPlan_div'>
                                                                        <p>{item?.gps_info?.date_time ? item?.gps_info?.date_time : '-'}</p>
                                                                        <p className='_vpText_warn'>{item?.gps_info?.status ? `${item?.gps_info?.status}` : '-'}</p>
                                                                        <span className='_vpText_danger'>{item?.gps_info?.duration ? item?.gps_info?.duration : '-'}</span>
                                                                    </div> : '-'} */}
                                                                    <p>{item?.address || " "}</p>
                                                                    <p className='_vpText_warn'>{item?.gps_info?.status || '-'}</p>
                                                                    <span className='_vpText_danger'>{utils.formatDurationShort(item?.gps_info?.duration)}</span>
                                                                </td>

                                                                <td>
                                                                    <div className='_drvPlan_div'>
                                                                        <p>{item?.driver_name ? item?.driver_name : '-'}</p>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div className='_vlGrpPlan_div'>
                                                                        <p> {item?.vehicle_group ? item?.vehicle_group : '-'} </p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    )
                                                })
                                                :
                                                (loading ?
                                                    <tr>
                                                        <td style={{ borderBottom: '1px solid var(--light-gray)', padding: '6px 18px' }} colSpan={11}>
                                                            <div className='__plaings'>
                                                                <Loading />
                                                            </div>
                                                        </td>
                                                    </tr> :
                                                    <tr>
                                                        <td style={{ borderBottom: '1px solid var(--light-gray)', padding: '6px 18px' }} colSpan={11}>
                                                            No Data Found
                                                        </td>
                                                    </tr>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {(vehiclePlaningList?.length > 0 && totalItems > 0) &&
                            <div className="paginationFt_avt ">
                                <CustomPagination
                                    totalItems={totalItems}
                                    itemsPerPage={itemsPerPage}
                                    currentPage={filter?.offset}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        }
                    </div>
                </div>

            </div >

            {(showSelectListModal?.type && showSelectListModal?.action) && <SelectListModal {...updateListProps} />}

            {updateModal.vehicle_id && <UpdateModal {...updateDataModal} />}
        </>
    )
}

export default VehiclePlanning